import * as tslib_1 from "tslib";
var TroubleshootingPage = /** @class */ (function () {
    function TroubleshootingPage(data) {
        this.parent = null;
        this.index = -1;
        this.items = [];
        this.data = data;
    }
    TroubleshootingPage.Compare = function (a, b) {
        if (a.SortIndex > b.SortIndex)
            return 1;
        else if (a.SortIndex < b.SortIndex)
            return -1;
        else
            return 0;
    };
    Object.defineProperty(TroubleshootingPage.prototype, "Parent", {
        get: function () {
            return this.parent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TroubleshootingPage.prototype, "Index", {
        get: function () {
            return this.index;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TroubleshootingPage.prototype, "HtmlKey", {
        get: function () {
            return this.data.htmlKey;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TroubleshootingPage.prototype, "Title", {
        get: function () {
            return this.data.title;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TroubleshootingPage.prototype, "SortIndex", {
        get: function () {
            return this.data.sortIndex;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TroubleshootingPage.prototype, "Data", {
        get: function () {
            return this.data;
        },
        enumerable: true,
        configurable: true
    });
    TroubleshootingPage.prototype.Add = function (item) {
        item.parent = this;
        item.index = this.items.length;
        this.items.push(item);
    };
    return TroubleshootingPage;
}());
export { TroubleshootingPage };
var TroubleshootingDirectory = /** @class */ (function (_super) {
    tslib_1.__extends(TroubleshootingDirectory, _super);
    function TroubleshootingDirectory(data) {
        var e_1, _a, e_2, _b;
        var _this = _super.call(this, null) || this;
        var pages = [];
        try {
            for (var _c = tslib_1.__values(data.pages), _d = _c.next(); !_d.done; _d = _c.next()) {
                var item = _d.value;
                //          console.log(item.title);
                pages.push(new TroubleshootingPage(item));
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
        try {
            for (var pages_1 = tslib_1.__values(pages), pages_1_1 = pages_1.next(); !pages_1_1.done; pages_1_1 = pages_1.next()) {
                var page = pages_1_1.value;
                var parent_1 = FindParent(page);
                if (parent_1 == null)
                    parent_1 = _this;
                parent_1.Add(page);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (pages_1_1 && !pages_1_1.done && (_b = pages_1.return)) _b.call(pages_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        _this.Sort();
        function FindParent(child) {
            var e_3, _a;
            try {
                for (var pages_2 = tslib_1.__values(pages), pages_2_1 = pages_2.next(); !pages_2_1.done; pages_2_1 = pages_2.next()) {
                    var page = pages_2_1.value;
                    if ((page != child) && (page.HtmlKey == child.Data.parentKey))
                        return page;
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (pages_2_1 && !pages_2_1.done && (_a = pages_2.return)) _a.call(pages_2);
                }
                finally { if (e_3) throw e_3.error; }
            }
            return null;
        }
        return _this;
    }
    TroubleshootingDirectory.prototype.Sort = function () {
        function Process(page) {
            var e_4, _a;
            page.items.sort(TroubleshootingPage.Compare);
            try {
                for (var _b = tslib_1.__values(page.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    Process(item);
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_4) throw e_4.error; }
            }
        }
        Process(this);
    };
    TroubleshootingDirectory.prototype.Find = function (htmlKey) {
        function Process(page) {
            var e_5, _a;
            if (result != null)
                return;
            try {
                for (var _b = tslib_1.__values(page.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    if (item.HtmlKey == htmlKey) {
                        result = item;
                        return;
                    }
                    else
                        Process(item);
                }
            }
            catch (e_5_1) { e_5 = { error: e_5_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_5) throw e_5.error; }
            }
        }
        var result = null;
        Process(this);
        return result;
    };
    TroubleshootingDirectory.prototype.Html = function () {
        function Process(page) {
            var e_6, _a;
            if (page.items.length == 0)
                return;
            result += "<ul>";
            try {
                for (var _b = tslib_1.__values(page.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    result += "<li>\n";
                    result += "<div class=\"menu-item\" id=\"" + item.HtmlKey + "\">";
                    result += "  <div class=\"menu-item-text\">" + item.Title + "</div>";
                    result += "  <div class=\"menu-item-arrow fa fa-angle-right\"></div>";
                    result += "</div>";
                    Process(item);
                    result += "</li>\n";
                }
            }
            catch (e_6_1) { e_6 = { error: e_6_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_6) throw e_6.error; }
            }
            result += "</ul>\n";
        }
        var result = "";
        Process(this);
        return result;
    };
    return TroubleshootingDirectory;
}(TroubleshootingPage));
export { TroubleshootingDirectory };
